<template>
  <div>
    <h1>Blog</h1>
    <div
      class="blogs--container"
      v-for="(post, index) in posts"
      v-bind:key="index"
    >
      <div class="blogs--container--left">
        <div class="blogs--container--date">{{ post.data.datepost }}</div>
        <div class="blogs--container--title">
          <router-link v-bind:to="'/blog/' + post.uid">
            {{ post.data.titlepost[0].text }}
          </router-link>
        </div>
        <div class="blogs--container--tag">
          <span class="tag">Tag </span>
          <span> {{ post.data.tag[0].text }}</span>
        </div>
        <div class="blogs--container--tag">
          <span class="tag">Website</span>
          <span
            ><a :href="post.data.website.url">{{
              post.data.websitename[0].text
            }}</a></span
          >
        </div>
        <router-link
          class="blogs--container--more"
          v-bind:to="'/blog/' + post.uid"
          >View post
        </router-link>
      </div>
      <router-link
        class="blogs--container--right"
        v-bind:to="'/blog/' + post.uid"
      >
        <img :src="post.data.imgpost.url" alt="" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Blogs",
  data() {
    return {
      posts: [],
      linkResolver: this.$prismic.linkResolver
    };
  },
  methods: {
    getContent() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at("document.type", "post"), {
          orderings: "[my.post.date desc]"
        })
        .then(response => {
          this.posts = response.results;
          console.log(this.posts);
        });
    }
  },
  created() {
    this.getContent();
  }
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Poppins";
}

img {
  max-width: 720px;
  width: 100%;
}

.blogs--container {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 50px 0;
  border-top: 2px solid #2d2d2f;
}

.blogs--container--left,
.blogs--container--right {
  position: relative;
  width: 50%;
  box-sizing: border-box;
  padding: 20px;
}

.blogs--container--title {
  font-size: 40px;
  font-weight: 700;
  margin: 25px 0 50px;
  transition: 0.3s;

  a {
    transition: 0.3s;
  }
  a:hover {
    color: #afa186;
    transition: 0.3s;
  }
}
.blogs--container--date {
  color: #7c7c83;
  font-size: 14px;
}

.blogs--container--tag {
  display: flex;
  margin: 10px 0;
  font-size: 14px;

  .tag {
    margin: 0 !important;
    width: 80px !important;
    color: #7c7c83;
  }

  span {
    color: #fff;
    margin-left: 10px;
  }

  a {
    color: #afa186;
  }
}

.blogs--container--more {
  position: absolute;
  bottom: 25px;
  color: #7c7c83;
  transition: 0.3s;

  &:hover {
    color: #fff;
    transition: 0.3s;
  }
}

a {
  text-decoration: none;
}
</style>
